/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zhuxuxi
 * @Date: 2022-11-17 17:34:06
 * @LastEditTime: 2022-11-17 17:44:30
 */
module.exports = {
  system: {
    title: 'Global tsunami warning wechat mini program'
  },
  btns: {
    lang: '中文'
  }
}
